import BackendClient from '../../backend-client';
import Export, { modelFactory } from './model';

export default class ExportClient extends BackendClient {
  constructor(options = {}) {
    super(modelFactory, options);
  }

  exportTicketsXLS = (filters = {}) => this.request('get', 'excel/I')({ filters }, {
    responseType: 'arraybuffer',
    headers: {
      'Content-Disposition': 'attachment; filename="Requests.xls; charset=UTF-8',
      'Content-Type': 'application/octet-stream; application/force-download;  application/download',
      'Content-Transfer-Encoding': 'binary',
      'Accept-Ranges': 'bytes',
    },
  });
}

export {
  Export,
};
